var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center py-1"},[_c('div',{staticClass:"text--gray hud3"},[_vm._v(_vm._s(this.label))]),_c('div',{staticClass:"ml-3 hud2 px-2 py-1 font-weight-bold"},[_vm._v(_vm._s(this.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }